import { Col, Row } from "antd";
import { EmptyContent } from "views/components/EmptyContent";
import { ErrorMessage } from "views/components/Message";
import { LoadingOutlined } from "@ant-design/icons";
import { TimeBlock } from "views/mobile/components/common/TimeBlockGroup";
import {
	addLabels,
	addListener,
	addSelected,
	exclude,
	excludeUnavailables,
	formatTimeblock,
	groupBy,
	parseTimeblock,
	sortAsc,
	timeblockGroupsAdapter,
} from "lib/timeblocks";
import { filter, map, pipe, reduce, sort } from "lib/functions";
import { useTimeBlocks, useTimeBlocksV1 } from "state/reservations/hooks";
import React, { useState } from "reactn";
import Skeleton from "react-loading-skeleton";
import afternoonIcon from "views/resources/icons/icono_tarde.svg";
import eveningIcon from "views/resources/icons/icono_vespertino.svg";
import morningIcon from "views/resources/icons/icono_manana.svg";
import styled from "styled-components";
import { TimeBlockTab } from "views/components/TimeBlockTab";
import { Tabs } from "antd";
const { TabPane } = Tabs;

export const Step2 = ({ onChange, date, officeSlug, lineSlug, v2, tz }) => {
	const callback = (key) => {};
	const [tbsv2, loading, error] = useTimeBlocks(
		lineSlug,
		officeSlug,
		date,
		v2
	);
	const [tbsv1, loading1, error1] = useTimeBlocksV1(
		lineSlug,
		officeSlug,
		date,
		v2
	);

	const [selectedTimeBlock, setSelectedTimeBlock] = useState(null);
	const onChangeWrapper = (onChange) => (ev) => {
		setSelectedTimeBlock(ev);
		onChange(ev);
	};

	const timeblockGroups = pipe(
		map(parseTimeblock(tz)),
		map(addLabels),
		map(addListener(onChangeWrapper(onChange))),
		map(addSelected(selectedTimeBlock)),
		sort(sortAsc),
		map(formatTimeblock(tz)),
		filter(excludeUnavailables),
		reduce(groupBy("label"), {}),
		timeblockGroupsAdapter
	)(v2 ? tbsv2 : tbsv1);

	if (loading || loading1)
		return (
			<TimeBlocksContainer align="middle" gutter={8}>
				{[0].map((_) => (
					<LoadingOutlined
						style={{
							fontSize: 38,
							color: "#145ab4",
							width: "100%",
						}}
					/>
				))}
			</TimeBlocksContainer>
		);

	if (error && error.message)
		//return <ErrorMessage error={error} />;
		return (
			<EmptyContent description="No hay bloques horarios disponibles" />
		);
	return (
		<>
			{timeblockGroups.map(TimeBlockGroup)}

			{!loading && timeblockGroups.length === 0 && (
				<EmptyContent description="No hay bloques horarios disponibles" />
			)}
		</>
	);
};

const TimeBlockGroup = ({ timeblocks, label }) => {
	if (timeblocks.length === 0) return null;
	const iconSrc =
		label === "Vespertino"
			? eveningIcon
			: label === "Tarde"
			? afternoonIcon
			: morningIcon;
	return (
		<>
			<LabelWrapper>
				<Icon src={iconSrc}></Icon>
				<Label>{label}</Label>
			</LabelWrapper>
			<TimeBlocksContainer align="middle" gutter={8}>
				{timeblocks.map((timeblock, i) => (
					<Col key={i}>
						<TimeBlock {...timeblock}></TimeBlock>
					</Col>
				))}
			</TimeBlocksContainer>
		</>
	);
};

const LabelWrapper = styled.div`
	display: flex;
	align-items: center;
	width: 120px;
	justify-content: space-evenly;
	margin-bottom: 12px;
`;

const Icon = styled.img`
	width: 24px;
	height: auto;
`;

const Label = styled.div`
	font-weight: 800;
	font-size: 1rem;
`;

// https://stackoverflow.com/a/34816625/1797161
const TimeBlocksContainer = styled(Row)`
	padding-bottom: 24px;
	width: 100%;
`;
